import React from "react";
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import './testimonial2.css';

const Testimonial2 = (props) => {

    const testimonial = [
        {
            Des: "I've been with the Roslindale Food Collective (RFC) for over 2 years, deeply enjoying the chance to help those facing food insecurity. Led by the inspiring Leah Arteaga, our team works collaboratively together every week to manage and distribute several thousand of pounds of food donations to the community. This experience every week enriches my life, making me feel appreciated and positive about the lives we are touching. I cherish our Sundays together and I'm hopeful for RFC's future growth and continued impact on more families in the community.",
            Title: 'Chris Ocnean',
            Sub: "Volunteer",
        },
        {
            Des: "As a long term volunteer off and on with the Sunday surplus food effort at the Lutheran church on Center St in JP, and previously at the Irving School I have seen the generous dedication of Leah Arteaga and other volunteers in persisting in this always evolving effort.  The way it is organized gives lots of room for volunteer autonomy with just enough structure to make it happen, no easy task. I come to the program first as a way to address food waste and second food insecurity.",
            Title: 'Ronald Beland',
            Sub: "Volunteer",
        },
        {
            Des: "I just want to say how grateful I am to Leah and her helpers for helping out myself, my daughter & mom. I'm a single mom who's struggling daily. Leah's golden heart helps out so many people in the community. There should be more people like her, she's really a gem!",
            Title: 'L.G.',
            Sub: "Beneficiary",
        },
        {
            Des: "I started volunteering 15 months ago and was struck by the big impact the program makes on those served. In a short period of time and with incredible teamwork, healthy food is unloaded, sorted, and assembled to distribute to the community. I enjoy working side by side with everyone and have built new friendships. Its been a rewarding experience. I am happy to be part of a group making a difference in the community.",
            Title: 'B.W.',
            Sub: "Volunteer",
        },
        {
            Des: "Being part of the Roslindale Food Collective has helped me build connections in my community, help those who must work longer to afford inflating grocery prices, and learn how neighbors can mobilize to reduce food waste. It gives me peace to know I can help others each week.",
            Title: 'Buddy',
            Sub: "Beneficiary turned to Volunteer.",
        },
        {
            Des: "Being a part of the Roslindale food program has been a wonderful experience for me, to be able to serve my community is such an honor. We have built a great team of volunteers and it truly feels like family, I am a resident of Roslindale and it's a great place to live. I have been blessed to help my community and to become a volunteer for the Roslindale Food Collective which has taken a special place in my heart.",
            Title: 'Janet N.',
            Sub: "Volunteer",
        }
    ]

    return (
        <section className="testimoninals-funfact-section testimonials-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-8 offset-lg-2 col-md-10 offset-md-1">
                        <div className="section-title-s3">
                            <span>#Testimonials</span>
                            <h2>Community Voices</h2>
                            <p>At Roslindale Food Collective, we believe in the power <br />of community support to overcome challenges. Here <br />are some voices from those who've joined us in this amazing journey. Together, we're making a difference.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="testimonials-slider testimonials-slider-area">
                            <Swiper
                                modules={[Navigation, A11y]}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                spaceBetween={30}
                                slidesPerView={1}
                                breakpoints={{
                                    1200: {
                                        slidesPerView: 3,
                                        spaceBetween: 30
                                    },
                                    991: {
                                        slidesPerView: 2,
                                        spaceBetween: 30
                                    },
                                    767: {
                                        slidesPerView: 1,
                                        spaceBetween: 30
                                    },
                                    480: {
                                        slidesPerView: 1,
                                        spaceBetween: 30
                                    }
                                }}
                            >
                                {testimonial.map((tesmnl, tsm) => (
                                    <SwiperSlide key={tsm}>
                                        <div className="testimonial-grid">
                                            <div className="testimonial-author">
                                                <div className="author-img">
                                                    {tesmnl.Title.charAt(0)}
                                                </div>
                                                <h5 className="author-name">{tesmnl.Title} - {tesmnl.Sub}</h5>
                                            </div>
                                            <p className="testimonial-text">
                                                {tesmnl.Des}
                                            </p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial2;